<template>
  <div>
    <headerNav title="设置支付密码" />
    <van-form @submit="confirm">
      <van-field v-if="ispay" v-model="payinput.oldpwd" type="password" name="旧密码" label="旧密码" placeholder="旧密码" />
      <van-field v-model="payinput.newpwd" type="password" name="新密码" label="新密码" placeholder="请输入新密码" :rules="[{ required: true, message: '请填写新密码' }]" />
      <van-field v-model="payinput.newpwd2" type="password" name="确认密码" label="确认密码" placeholder="请再次输入新密码" :rules="[{ required: true, message: '请填写确认密码' }]" />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit" :loading="loading" loading-text="设置中..." class="setbtns" :color="$abctheme.basecolor">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import request from "@/config/ajax";

import Util from "@/config/Util";

export default {
  data() {
    return {
      payinput: {
        oldpwd: "",
        newpwd: "",
        newpwd2: "",
      },
      loading: false,
      ispay: false,
    };
  },
  created() {
    if (!Util.abp.session.userId) {
      this.$router.push({ path: "/login/password" });
    } else {
        request
        .post("/api/services/app/PhoneUser/IsSetPayPwd").then(x=>{
if(x.result){
  this.ispay=true;
}
        })
    }
  },
  methods: {
    confirm() {
      this.loading = true;
      request
        .post("/api/services/app/PhoneUser/SetPayPwd", this.payinput)
        .then(() => {
          this.$toast("设置成功");
          //返回上个页面并触发方法
          if (this.ispay) {
            this.$emit("setpwd");
          }
          //调用router回退页面
          this.$router.go(-1);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
